import { COMPLIANCE_AREA_CONTRACT_MANAGEMENT_ID } from "../../../../annualWheel/annualWheelDialog/AnnualWheelDialog.types";
import { ContractBasicInfo } from "../../../../annualWheel/RelativeDate.types";
import { ActivityFormModel } from "../../../../annualWheel/activityForm/ActivityFormModel";
import { ActivityScheduleModel, defaultActivityInterval } from "../../../../annualWheel/activityForm/ActivityScheduleModel";
import { RecurringIntervalType } from "../../../../annualWheel/AnnualWheel.types";
import { ObligationDuplicateMatch, ObligationSuggestionPage, ObligationSuggestionViewModel } from "./ObligationExtraction.types";

export function suggestionToPage(
    suggestion: ObligationSuggestionViewModel,
    contractId: string,
    contractDocumentId: string,
    contractInfo: ContractBasicInfo | undefined
): ObligationSuggestionPage {
    return {
        suggestion,
        model: ActivityFormModel.create({
            name: suggestion.name,
            description: suggestion.description ?? null,
            areas: [COMPLIANCE_AREA_CONTRACT_MANAGEMENT_ID],
            // The obligation panel seeds business areas from the contract in an effect once its query resolves.
            // Here the contract is already loaded, so they go straight into the model.
            businessAreas: contractInfo?.businessAreaIds ?? [],
            contractId,
            contractDocumentId,
            section: suggestion.section ?? undefined,
            clause: suggestion.clause,
            // No start date, so the user has to decide when the first task falls due.
            schedule: ActivityScheduleModel.create({
                interval: suggestion.interval ?? defaultActivityInterval,
                recurrenceIntervalType: suggestion.recurringIntervalType ?? RecurringIntervalType.Month,
                contractInfo,
            }),
        }),
        clauseReplaced: false,
        // A clause the locator could not find carries the model's unverified wording, so it starts excluded
        // and the user has to opt it back in. A repeated clause starts excluded for the same reason: the
        // same quoted passage is the same duty. A repeated name only warns - titles are short imperatives
        // and collide, so excluding on one would drop a genuinely different obligation unasked.
        excluded: !suggestion.clauseLocated || suggestion.duplicateMatch === ObligationDuplicateMatch.Clause,
        showError: false,
        created: false,
    };
}
